function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
const SvgTwitter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: props.color || 'currentColor',
  "data-animate": props.isAnimate || false,
  "data-interactive": props.animateOnInteraction || false
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M6.203 8.91.023 0h4.78L16 15.982h-4.892L6.911 9.93 1.609 16H0l6.203-7.09Zm5.47 6.008L2.061 1.064h2.18l9.707 13.854h-2.277Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.572.016 9.602 6.85l-.71-1.012L13.987.015l1.585.001Z"
}));
export default SvgTwitter;